import { h } from 'preact';
import React, { Component } from 'react';
import { PMUSSettings } from './PMUSSettings';
import { PMUSNeutralSettings } from '../PMUSNeutral/PMUSNeutralSettings';
import NeutralButtons from '../PMUSNeutral/NeutralButtons';

import './PMUS.css';
import Switch from './Components/Switch';
import { makeText, isActionAllowed } from '../../util';

export class PMUS extends Component {
  state = {
    tab: this.props.pmTab ? this.props.pmTab || 'purposes' : this.props.message.defaultTab || 'purposes',
    loading: true
  }

  changeTab = (tab) => this.setState({ tab })

  linkHover = (e, which) => {
    e.target.style.color = which.color;
    e.target.style.textDecoration = which.textDecoration;
    e.target.style.fontWeight = which.fontWeight;
  }

  createPrivacyPolicyDiv = ({ privacyPolicySectionText, privacyPolicySectionLink }) => {
    const parts = privacyPolicySectionText.split(/[\[\]]/);
    const Settings = this.props.neutralPm
    ? new PMUSNeutralSettings(this.props.component.settings)
    : new PMUSSettings(this.props.component.settings);
    const pplStyles = { ...Settings.pplSpacing, ...Settings.pplFont };
    const linkAttributes = {
      style: Settings.linkStyle,
      onMouseOver: (e) => this.linkHover(e, Settings.linkHoverStyle),
      onMouseOut: (e) => this.linkHover(e, Settings.linkStyle)
    };

    return (
      <div style={pplStyles}>
        {parts[0]}
        <a {...linkAttributes} href={privacyPolicySectionLink}>{parts[1]}</a>
        {parts[2]}
      </div>
    );
  }

  createIdentificationListDiv = (categories, i) => {
    const Settings = this.props.neutralPm
    ? new PMUSNeutralSettings(this.props.component.settings)
    : new PMUSSettings(this.props.component.settings);
    const styles = { ...Settings.identificationListSpacing, ...Settings.identificationListFont };

    // display identificationList only for last category that has it
    const followingCats = categories.slice(i+1);
    if (followingCats.some(cat => cat.identificationList)) return null;
        
    return (
      <div style={styles}>{categories[i].identificationList}</div>
    );
  }

  supportsGPC = () => {
    const isGPCEnabled = 'globalPrivacyControl' in navigator && navigator.globalPrivacyControl;
    return isGPCEnabled;
  }

  render() {
    const data = { ...this.props.pmData } || {};

    if (this.props.isFirstLayer) {
      const sensDataStack = data.stacks && data.stacks[0];
      const filteredCats = sensDataStack ? data.categories.filter(cat => sensDataStack.childCategories.includes(cat._id)) : [];
      data.categories = filteredCats;
    }

    if (data.categories && !data.categories.length) {
      return (<div className='no-cats-messagee'>No categories to display</div>);
    }

    const Settings = this.props.neutralPm
    ? new PMUSNeutralSettings(this.props.component.settings)
    : new PMUSSettings(this.props.component.settings);
    // const { language } = this.props;
    const { dev, name, accessName, description, content, toggle, child, value, language, titleContent, vendors, isCustom, locked, consentType, isApple, appleDataBrokerLetter, usePurModel, toggleCategory, toggleStack, isFirstLayer, neutralPm } = this.props;

    /* DEV MODE ONLY */
    let devActions = {}, selected = false, path = JSON.stringify(this.props.path);
    if (this.props.dev) {
      devActions = { ...this.props.dev.hover };
      selected = this.props.dev.current === path;
    }

    const sectionStyles = {};
    sectionStyles.minHeight = Settings.minHeight.type === 'auto' ? 'auto' : Settings.minHeight.value + Settings.minHeight.type;
    sectionStyles.maxHeight = Settings.maxHeight.type === 'auto' ? 'auto' : Settings.maxHeight.value + Settings.maxHeight.type;
    let className = 'message-component pm-us no-children' + this.props.className;
    if (this.props.neutralPm) className += ' neutral-pm';
    const vendorList = data.vendors || [];
    if (Settings.alphabetizeVendors) {
      vendorList.sort((a, b) =>{
        if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
        if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
        return 0;
      });
    }

    const toggleText = makeText(Boolean(dev), Settings, 'toggleText', language);
    const toggleOffText = makeText(Boolean(dev), Settings, 'toggleOffText', language);

    const allStackCategories = data.stacks && data.stacks.reduce((childCategories, stack) => childCategories.concat(stack.childCategories), []);
    const categoriesNotInStacks = data.categories && data.categories.filter(category => !allStackCategories.includes(category._id)).filter(category => !category.hide);

    const descriptionStyles = { ...Settings.descriptionSpacing, ...Settings.descriptionFont };
    const switchStyles = { ...Settings.nameSpacing };
    const nameStyles = { ...Settings.nameFont };
    const stackCategoryStyles = { ...Settings.stackCategoriesSpacing, ...Settings.stackCategoriesFont }
    const scrollStyles = {};
    scrollStyles.minHeight = Settings.minHeight.type === 'auto' ? 'auto' : Settings.minHeight.value + Settings.minHeight.type;
    scrollStyles.maxHeight = Settings.maxHeight.type === 'auto' ? 'auto' : Settings.maxHeight.value + Settings.maxHeight.type;
    const borderStyle = { borderBottomColor: Settings.borderColor };
    const gpcStyles = { ...Settings.gpcSpacing, ...Settings.gpcFont };
    const gpcTextLang = Settings.languages[language] && Settings.languages[language].gpcText;
    const gpcText = gpcTextLang || Settings.languages.EN.gpcText;
    const containerStyles = {
      ...Settings.padding,
      ...Settings.margin,
      ...Settings.border
    };
    containerStyles.background = Settings.background;

    const displayGPC = () => {
      let displayGPC = !isFirstLayer &&
      Settings.gpcVisible &&
      data.categories &&
      data.categories.some(c => c.respectGPC);

      if (!this.props.dev) {
        displayGPC = displayGPC && this.supportsGPC();
      }

      return displayGPC;
    }

    return (
      <div style={containerStyles} className={selected ? className + ' on-active' : className} path={this.props.dev ? path : null} {...devActions}>
        <div className="categories-container">
          {data.stacks && data.stacks.length > 0 &&
            data.stacks.map(stack => {
              return (
                <div className='category-container' style={borderStyle}>
                  <div className='description' style={descriptionStyles}>{stack.description || 'description description description'}</div>
                  <ul className='stack-categories' style={scrollStyles}>
                    { stack.childCategories.map(id => {
                      const category = data.categories.find(cat => cat._id === id);
                      return (
                        <li className='stack-category' style={stackCategoryStyles}>
                          {category.name}
                        </li>
                      )
                    })}
                  </ul>
                  <div className='switch-container' style={switchStyles}>
                    <div className='name' style={nameStyles}>{stack.name}</div>
                    {!isFirstLayer && (!neutralPm ? (
                        <Switch
                          value={stack}
                          checked={stack.isNegative ? !stack.enabled : stack.enabled}
                          type={Settings.toggleType}
                          color={Settings.toggleColor}
                          colorActive={Settings.toggleActiveColor}
                          offColor={Settings.toggleOffColor}
                          offActiveColor={Settings.toggleOffActiveColor}
                          text={toggleText}
                          offText={toggleOffText}
                          toggleCategory={toggleCategory}
                          toggleStack={toggleStack}
                          neutralPm={this.props.neutralPm}
                        /> 
                      )
                      : (
                        <NeutralButtons
                          settings={Settings}
                          toggleCategory={toggleCategory}
                          toggleStack={toggleStack}
                          vendors={vendors}
                          value={stack}
                          child={child}
                          dev={dev}
                          language={language}
                        />
                      ))}
                    </div>
                    { stack.privacyPolicySectionLink ?
                      this.createPrivacyPolicyDiv(stack) :
                      null
                    }
                  </div>
              )
            })
          }
          {categoriesNotInStacks && categoriesNotInStacks.length > 0 &&
            categoriesNotInStacks.map((category, i) => (

            <div className='category-container'>
              <div className='description' style={descriptionStyles}>{category.description}</div>
              <div className='switch-container' style={switchStyles}>
                <div className='name' style={nameStyles}>{category.name}</div>
                {!neutralPm ? (
                  <Switch
                    value={category}
                    checked={category.isNegative ? !category.enabled : category.enabled}
                    type={Settings.toggleType}
                    color={Settings.toggleColor}
                    colorActive={Settings.toggleActiveColor}
                    offColor={Settings.toggleOffColor}
                    offActiveColor={Settings.toggleOffActiveColor}
                    text={toggleText}
                    offText={toggleOffText}
                    toggleCategory={toggleCategory}
                  /> 
                )
                : (
                  <NeutralButtons
                    settings={Settings}
                    toggleCategory={toggleCategory}
                    toggleStack={toggleStack}
                    vendors={vendors}
                    value={category}
                    enabled={category.isNegative ? !category.enabled : category.enabled}
                    child={child}
                    dev={dev}
                    language={language}
                  />
                )}
              </div>
              { category.privacyPolicySectionLink ?
                this.createPrivacyPolicyDiv(category) :
                null
              }
              { category.identificationList ?
                this.createIdentificationListDiv(categoriesNotInStacks, i) :
                null
              }
            </div>
          ))}

        </div>
        { displayGPC() ?
          <div className='gpc' style={gpcStyles}>
            <span>&#9432;</span> { gpcText }
          </div> :
          null
        }
      </div>
    );
  }
}
